module.exports = __webpack_public_path__ + "img/currency.3cfa3b9c.png";